import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import routeConfiguration from '../../routeConfiguration';
import { pathByRouteName } from '../../util/routes';

export const NamedLink = ({
  name,
  params = {},
  title = null,
  id = null,
  to = {},
  children = null,
  className = '',
  style = {},
  activeClassName = 'NamedLink_active',
  target = null,
}) => {
  const location = useLocation();
  const pathname = pathByRouteName(name, routeConfiguration(), params);
  
  const active = location.pathname === pathname;

  const aElemProps = {
    className: classNames(className, { [activeClassName]: active }),
    style,
    title,
    target,
    id,
  };

  return (
    <Link to={{ pathname, ...to }} {...aElemProps}>
      {children}
    </Link>
  );
};

NamedLink.displayName = 'NamedLink';

export default NamedLink;